<template>
  <div class="title">
    <div class="content">
      <div class="left">
        <img src="/static/img/header/logo.png" alt="logo"/>
        <span class="lefttext">{{title}}</span>
      </div>
      <div class="right">
        <img src="/static/img/header/phone.png">
        <span class="righttext">咨询热线：</span><span class="tel">{{tel}}</span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'homeTitle',
    data () {
      return {
        title: '木材全产业链综合服务平台',
        tel: '400-168-6606'
      }
    }
  }
</script>

<style scoped>
  .title {
    width: 980px;
    height: 111px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
  }
  .content {
    display: inline-block;
    *display: inline;
    width: inherit;
    margin-left: auto;
    margin-right: auto;

  }
  .left {
    float: left;
  }

  .right {
    float: right;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .lefttext {
    margin-left: 20px;
    vertical-align: middle;
    font-size: 16px;
    color: rgb(136,136,136)
  }
  .righttext {
    margin-left: 10px;
    vertical-align: middle;
    /*font-family: 'Helvetica-Bold', 'Helvetica Bold', 'Helvetica';*/
    font-weight: normal;
    font-size: 20px;
    font-style: normal;
    color: rgb(73,73,73);
  }

  .tel {
    margin-left: 10px;
    vertical-align: middle;
    /*font-family: 'Helvetica-Bold', 'Helvetica Bold', 'Helvetica';*/
    font-weight: normal;
    font-size: 20px;
    font-style: normal;
    color: rgb(255,136,0);
  }
  .right img {
    max-width: 50px;
    max-height: 50px;
  }
</style>



// WEBPACK FOOTER //
// HomeTitle.vue?66835d55